import {colors} from 'shells/colors/colors';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import {ENGAGEMENT_LEAD_CONFIG} from '../consts';
import type {EngagementLeadType} from '../consts';

import styles from './engagement-leads-banner.module.css';

interface Props {
    type: EngagementLeadType;
    count: number;
}

export function EngagementLeadBannerItem(props: Props) {
    const config = ENGAGEMENT_LEAD_CONFIG[props.type];
    const Icon = config.icon;

    return (
        <Stack isHorizontal={true} spacing={8} alignItems='center'>
            <Body color='dark' size='large' isBold={true}>
                {props.count.toLocaleString()}
            </Body>
            <Stack isHorizontal={true} spacing={4} alignItems='center'>
                <span className={styles.icon}>
                    <Icon size={16} color={colors.greyLt} alignCenter={true} />
                </span>
                <span className={styles.actionText}>
                    <Body color='light'>{config.text}</Body>
                </span>
            </Stack>
        </Stack>
    );
}
